export default __webpack_public_path__ + "static/media/vroom4.9f884560.PNG";